// src/data/sounds.js
//
// Built-in ambient sound catalog. Drop licensed/royalty-free audio files into
// assets/sounds/ and point `uri` at the local require() — or host them
// remotely and use a URL string instead (AudioEngine accepts either since
// it's passed straight to expo-av).
//
// require() with a static string is what Metro bundler needs for local
// assets, so keep these paths literal (no dynamic string building).

export const AMBIENT_SOUNDS = [
  {
    id: 'rain',
    name: 'Rain',
    category: 'weather',
    uri: require('../../assets/sounds/rain.mp3'), // default = Version 1
    icon: 'rainy',
    jukeboxEnabled: true,
    versions: [
      { id: 'rain-v1', label: 'Version 1', uri: require('../../assets/sounds/rain.mp3') },
      { id: 'rain-v2', label: 'Version 2', uri: require('../../assets/sounds/rain-v2.mp3') },
    ],
  },
  {
    id: 'birds',
    name: 'Birdsong',
    category: 'nature',
    uri: require('../../assets/sounds/birds.mp3'),
    icon: 'leaf',
    jukeboxEnabled: true,
    versions: [
      { id: 'birds-v1', label: 'Version 1', uri: require('../../assets/sounds/birds.mp3') },
      { id: 'birds-v2', label: 'Version 2', uri: require('../../assets/sounds/birds-v2.mp3') },
    ],
  },
  {
    id: 'water',
    name: 'Running Water',
    category: 'nature',
    uri: require('../../assets/sounds/water.mp3'), // default = Version 1
    icon: 'water',
    jukeboxEnabled: true,
    versions: [
      { id: 'water-v1', label: 'Version 1', uri: require('../../assets/sounds/water.mp3') },
      { id: 'water-v2', label: 'Version 2', uri: require('../../assets/sounds/water-v2.mp3') },
    ],
  },
  {
    id: 'melody',
    name: 'Calm Melody',
    category: 'music',
    uri: require('../../assets/sounds/melody.mp3'),
    icon: 'musical-notes',
  },
  {
    id: 'nature-sounds',
    name: 'Nature Sounds',
    category: 'nature',
    uri: require('../../assets/Audacity/nature-sounds.mp3'),
    icon: 'sunny',
  },
  {
    id: 'fireplace',
    name: 'Fireplace',
    category: 'ambient',
    uri: require('../../assets/Audacity/fireplace.mp3'),
    icon: 'flame',
  },
  {
    id: 'piano',
    name: 'Piano',
    category: 'music',
    uri: require('../../assets/sounds/piano.mp3'),
    icon: 'musical-note',
  },
  {
    id: 'wind-leaves',
    name: 'Wind & Leaves',
    category: 'nature',
    uri: require('../../assets/sounds/wind-leaves.mp3'),
    icon: 'partly-sunny',
  },
  {
    id: 'ocean-waves',
    name: 'Ocean Waves',
    category: 'nature',
    uri: require('../../assets/Audacity/ocean-waves.mp3'),
    icon: 'water',
  },
  {
    id: 'sleep-meditation',
    name: 'Sleep Meditation',
    category: 'meditation',
    uri: require('../../assets/sounds/sleep-meditation.mp3'),
    icon: 'moon',
  },
];

// Separate, slightly more "alert" loop set for the Study screen — softer
// on melody, no birds/rain that can be distracting during focus work.
export const STUDY_SOUNDS = [
  {
    id: 'study-lofi',
    name: 'Lo-fi Focus',
    uri: require('../../assets/sounds/study-lofi.mp3'),
    icon: 'musical-note',
  },
  {
    id: 'study-white-noise',
    name: 'White Noise',
    uri: require('../../assets/sounds/white-noise.mp3'),
    icon: 'radio',
  },
  {
    id: 'coffee-shop',
    name: 'Coffee Shop',
    uri: require('../../assets/sounds/coffee-shop.mp3'),
    icon: 'cafe',
  },
  {
    id: 'calm-focus',
    name: 'Calm Focus',
    uri: require('../../assets/sounds/calm-focus.mp3'),
    icon: 'fitness',
  },
  {
    id: 'study-jazz',
    name: 'Study Jazz',
    uri: require('../../assets/sounds/study-jazz.mp3'),
    icon: 'musical-notes',
  },
];

// Gentler set for the Kids Sleep screen — softer, simpler sounds parents can
// pick for a child's room. Reuses rain.mp3 from the main library; lullaby
// and heartbeat need their own files (see assets/sounds/).
export const KIDS_SOUNDS = [
  {
    id: 'kids-lullaby',
    name: 'Lullaby',
    uri: require('../../assets/sounds/lullaby.mp3'),
    icon: 'musical-notes',
  },
  {
    id: 'kids-rain',
    name: 'Soft Rain',
    uri: require('../../assets/sounds/soft-rain.mp3'),
    icon: 'rainy',
  },
  {
    id: 'kids-heartbeat',
    name: 'Heartbeat',
    uri: require('../../assets/sounds/heartbeat.mp3'),
    icon: 'heart',
  },
  {
    id: 'kids-ocean-waves',
    name: 'Ocean Waves',
    uri: require('../../assets/Audacity/kids-ocean-waves.mp3'),
    icon: 'water',
  },
  {
    id: 'night-crickets',
    name: 'Night Crickets',
    uri: require('../../assets/sounds/night-crickets.mp3'),
    icon: 'moon',
  },
];

export const KIDS_TIMER_PRESETS = [15, 20, 30, 45]; // minutes — shorter than the adult presets

// Default categories for the user's personal library. Users can add their
// own custom categories too (see LibraryContext.js).
export const DEFAULT_CATEGORIES = ['Sleep', 'Study', 'Focus', 'Relax'];
